const initialValues = {
  locationName: "",
  addressLine1: "",
  addressLine2: "",
  cityName: "",
  stateId: "",
  stateName: "",
  stateShortName: "",
  zipCode: "",
  contactName: "",
  contactPhone: "",
  contactPhoneExtension: "",
  instructionsOrRestrictions: "",
  dayOfWeekRestricted: [],
};

export default initialValues;
